const url = `https://todo.api.devcode.gethired.id`;
export default url;
